import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubmitCoachingModal from './SubmitCoachingModal';

export class OpportunityFooter extends Component {
  state = {
    showModal: false,
  }

  handleOpenModal = () => {
    this.setState({ showModal: true });
  } 

  handleCloseModal = () => {
    this.setState({ showModal: false });
  }

  render() {
    const { 
      handleOpenModal,
      handleCloseModal,
      state: { showModal },
      props: {
        handleSubmit,
        handleCancel,
      }
    } = this;
    

    return (
      <div className="ac-op-footer">
        <div className="ac-op-footer__wrap shared__flex-cen-fe">
          <button
            type="button"
            onClick={handleCancel}
            className="ac-op-footer__cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleOpenModal}
            className="ac-op-footer__submit"
          >
            Submit
          </button>
        </div>
        <SubmitCoachingModal 
          showModal={showModal} 
          handleSubmit={handleSubmit}
          handleCloseModal={handleCloseModal}
        />
      </div>
    );
  }
}

OpportunityFooter.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

OpportunityFooter.defaultProps = {
};

export default OpportunityFooter;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/OpportunityFooter.js